import styled from 'styled-components';

const MonitoringWrapper = styled.div``;

export { MonitoringWrapper };
